import { Navigate } from 'react-router-dom';

import { login as loginRoute } from 'components/layouts/Public/routes';

export const PrivateRoute = () => {
  return <Navigate to={loginRoute} />;
};
